var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M512,256c0,82.317-38.86,155.564-99.234,202.397C369.455,492.001,315.068,512,256,512 s-113.455-19.999-156.766-53.603C38.86,411.564,0,338.317,0,256C0,114.615,114.615,0,256,0S512,114.615,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006BC0"
    },
    d: "M441.992,119.474l-29.226,338.923C369.455,492.001,315.068,512,256,512 s-113.455-19.999-156.766-53.603L70.008,119.474H441.992z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0096DC"
    },
    points: "255.997,151.338 255.997,505.296 378.269,470.777 405.545,151.338 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "364.036,289.787 275.85,289.787 367.999,242.89 371.981,195.746 140.013,195.746  144.072,243.811 237.189,243.811 147.845,288.484 152.002,337.723 152.002,337.723 311.376,337.723 306.152,396.366 255.997,409.95  203.752,395.321 202.446,358.75 153.778,358.75 159.866,430.848 255.997,458.015 352.127,430.848 364.039,289.779 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#222123"
    },
    points: "165.352,67.224 165.352,33.787 213.417,33.787 213.417,15.676 147.937,15.676  147.937,85.335 213.417,85.335 213.417,67.224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#222123"
    },
    points: "241.542,42.93 241.542,34.57 289.347,34.57 289.347,33.787 289.347,15.676 223.866,15.676  223.866,58.864 270.799,58.864 270.799,67.224 223.866,67.224 223.866,85.335 289.347,85.335 289.347,67.224 289.347,42.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#222123"
    },
    points: "316.252,42.93 316.252,34.57 364.056,34.57 364.056,33.787 364.056,15.676 298.576,15.676  298.576,58.864 345.509,58.864 345.509,67.224 298.576,67.224 298.576,85.335 364.056,85.335 364.056,67.224 364.056,42.93  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.d237bf29.svg";
export { ForwardRef as ReactComponent };